{
  "name": "@workspace/source",
  "version": "0.3.3",
  "license": "MIT",
  "packageManager": "pnpm@11.22.0",
  "engines": {
    "npm": "Please use pnpm instead of NPM to install dependencies",
    "yarn": "Please use pnpm instead of Yarn to install dependencies",
    "pnpm": ">=11.22.0",
    "node": ">=24.0.0"
  },
  "scripts": {
    "prepare": "husky",
    "-- API --": "--------------- API ---------------",
    "build:core-api": "nx run-many -t build -p api-core-user api-core-public api-core-webhook api-core-auth api-core-admin api-common api-config data-types --configuration=development --parallel=8",
    "watch:core-api": "nx run-many -t build --projects=tag:scope:core --watch --configuration=development --parallel=4",
    "build:etxe-api": "nx run-many -t build -p api-etxe-user api-etxe-public api-etxe-admin --configuration=development --parallel=3",
    "watch:etxe-api": "nx run-many -t build --projects=tag:scope:etxe --watch --configuration=development --parallel=3",
    "watch:all-api": "nx run-many -t build --projects=tag:type:api --watch --configuration=development --parallel=8",
    "sms:webhook": "./tools/scripts/configure-sms-gateway-webhook.sh",
    "-- DB --": "--------------- DB ---------------",
    "build:db-seeder": "nx build --configuration=development db-seeder",
    "import:agent-cards": "nx run db-seeder:import-agent-cards",
    "-- WORKER --": "--------------- WORKER ---------------",
    "build:core-worker": "nx build --configuration=development api-core-worker",
    "watch:core-worker": "nx build api-core-worker --watch",
    "-- NG --": "-------------- ANGULAR --------------",
    "start:etxe-ng-admin": "npx nx serve ng-etxe-admin --configuration local",
    "start:etxe-ng-public": "npx nx serve ng-etxe-public --configuration local",
    "start:etxe-ng-owner": "npx nx serve ng-etxe-owner --configuration local",
    "start:etxe-ng-agent": "npx nx serve ng-etxe-agent --configuration local",
    "start:etxe-keycloak-theme": "THEME_ENV=local npx nx serve keycloak-theme --configuration local",
    "storybook:etxe-keycloak-theme": "npx nx storybook keycloak-theme",
    "build:etxe-keycloak-theme": "npx nx build-keycloak keycloak-theme",
    "build:all-ng": "nx run-many -t build -p ng-etxe-admin ng-etxe-public ng-etxe-owner ng-etxe-agent --parallel=4",
    "-- FORMAT --": "-------------- FORMATTING --------------",
    "format": "nx format:write --all",
    "format:check": "nx format:check --all",
    "-- RELEASE --": "-------------- RELEASE --------------",
    "release": "nx release",
    "release:patch": "nx release patch",
    "release:minor": "nx release minor",
    "release:major": "nx release major",
    "-- SONAR --": "-------------- SONARQUBE --------------",
    "sonar:scan": "pnpm dlx sonarqube-scanner",
    "sonar:export": "node ../scripts/export-sonar-issues.js"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "22.1.5",
    "@angular/cdk": "22.1.5",
    "@angular/common": "22.1.5",
    "@angular/compiler": "22.1.5",
    "@angular/core": "22.1.5",
    "@angular/forms": "22.1.5",
    "@angular/material": "22.1.5",
    "@angular/material-luxon-adapter": "22.1.5",
    "@angular/platform-browser": "22.1.5",
    "@angular/platform-server": "22.1.5",
    "@angular/router": "22.1.5",
    "@angular/ssr": "22.1.7",
    "@aws-sdk/client-s3": "^3.1127.0",
    "@aws-sdk/client-ses": "^3.1127.0",
    "@aws-sdk/s3-request-presigner": "^3.1127.0",
    "@faker-js/faker": "^10.6.0",
    "@keycloakify/angular": "22.1.0",
    "@nestjs/axios": "^12.0.1",
    "@nestjs/bullmq": "^12.0.0",
    "@nestjs/common": "^12.3.2",
    "@nestjs/config": "^12.0.1",
    "@nestjs/core": "^12.3.2",
    "@nestjs/jwt": "^12.0.3",
    "@nestjs/mongoose": "^12.0.0",
    "@nestjs/platform-node": "^12.3.2",
    "@nestjs/swagger": "^12.0.5",
    "@nestjs/terminus": "^12.1.0",
    "@nestjs/throttler": "^6.6.0",
    "@ngrx-toolkit/core": "^22.0.1",
    "@ngrx/signals": "22.0.1",
    "@stripe/stripe-js": "^9.15.0",
    "@tailwindcss/vite": "^4.3.3",
    "@types/compression": "^1.8.1",
    "@willsoto/nestjs-prometheus": "^6.1.1",
    "angular-auth-oidc-client": "^22.0.0",
    "axios": "1.20.0",
    "bcryptjs": "^3.0.3",
    "bson": "^7.3.3",
    "bson-objectid": "^2.0.4",
    "bullmq": "^6.3.6",
    "check-disk-space": "^3.4.0",
    "class-transformer": "^0.5.1",
    "class-validator": "^0.15.1",
    "clsx": "^2.1.1",
    "colorjs.io": "^0.7.1",
    "compression": "^1.8.2",
    "cookie-parser": "^1.4.7",
    "express": "^5.2.1",
    "ioredis": "^6.0.0",
    "jsonwebtoken": "^9.0.3",
    "keycloak-connect": "^26.1.1",
    "keycloakify": "^11.16.0",
    "leaflet": "^1.9.4",
    "libphonenumber-js": "^1.13.13",
    "luxon": "^3.7.2",
    "maxmind": "^5.0.7",
    "mime-types": "^3.0.2",
    "mongoose": "^9.10.1",
    "morgan": "^1.12.1",
    "multer": "^2.4.0",
    "nest-keycloak-connect": "2.0.0-alpha.2",
    "ngx-cookie-service": "22.0.0",
    "ngx-skeleton-loader": "^13.0.0",
    "nodemailer": "^10.0.10",
    "prom-client": "^15.1.3",
    "pug": "^3.0.4",
    "reflect-metadata": "^0.2.2",
    "rxjs": "^7.8.2",
    "sharp": "^0.35.4",
    "stripe": "^22.6.1",
    "tailwind-merge": "^3.6.0",
    "tailwindcss": "^4.3.3",
    "tslib": "^2.8.1",
    "ua-parser-js": "^2.0.9",
    "uuid": "^14.0.2",
    "xlsx": "^0.18.5",
    "zod": "^4.5.4"
  },
  "devDependencies": {
    "@analogjs/platform": "2.7.2",
    "@analogjs/storybook-angular": "2.7.2",
    "@analogjs/vite-plugin-angular": "2.7.2",
    "@analogjs/vitest-angular": "2.7.2",
    "@angular-devkit/architect": "0.2201.7",
    "@angular-devkit/core": "22.1.7",
    "@angular-devkit/schematics": "22.1.7",
    "@angular/build": "22.1.7",
    "@angular/cli": "22.1.7",
    "@angular/compiler-cli": "22.1.5",
    "@angular/language-service": "22.1.5",
    "@commitlint/cli": "^21.2.2",
    "@commitlint/config-conventional": "^21.2.2",
    "@eslint/js": "^10.0.1",
    "@nestjs/schematics": "^12.0.12",
    "@nestjs/testing": "^12.3.2",
    "@nx/angular": "23.2.0",
    "@nx/devkit": "23.2.0",
    "@nx/docker": "23.2.0",
    "@nx/eslint": "23.2.0",
    "@nx/eslint-plugin": "23.2.0",
    "@nx/js": "23.2.0",
    "@nx/nest": "23.2.0",
    "@nx/node": "23.2.0",
    "@nx/vite": "23.2.0",
    "@nx/vitest": "23.2.0",
    "@nx/web": "23.2.0",
    "@nx/webpack": "23.2.0",
    "@nx/workspace": "23.2.0",
    "@schematics/angular": "22.1.7",
    "@storybook/angular": "^10.6.0",
    "@swc-node/register": "~1.12.1",
    "@swc/core": "~1.16.2",
    "@swc/helpers": "~0.5.21",
    "@tailwindcss/postcss": "^4.3.3",
    "@tailwindcss/typography": "0.5.20",
    "@types/express": "^5.0.6",
    "@types/geojson": "^7946.0.16",
    "@types/jsonwebtoken": "^9.0.10",
    "@types/leaflet": "^1.9.22",
    "@types/luxon": "^3.7.5",
    "@types/mime-types": "^3.0.1",
    "@types/morgan": "^1.9.10",
    "@types/multer": "^2.2.0",
    "@types/node": "26.4.0",
    "@types/nodemailer": "^8.0.1",
    "@types/pug": "^2.0.10",
    "@typescript-eslint/utils": "^8.70.0",
    "angular-eslint": "22.5.0",
    "esbuild": "^0.28.2",
    "esbuild-visualizer": "^0.7.0",
    "eslint": "^10.10.0",
    "eslint-config-prettier": "^10.1.8",
    "husky": "^9.1.7",
    "jsdom": "^30.0.1",
    "jsonc-eslint-parser": "^3.3.0",
    "lint-staged": "^17.5.0",
    "nx": "23.2.0",
    "nx-remotecache-s3": "^1.2.2",
    "only-allow": "^1.2.2",
    "postcss": "^8.5.28",
    "prettier": "3.9.6",
    "prettier-plugin-organize-imports": "^4.3.0",
    "prettier-plugin-packagejson": "3.0.2",
    "prettier-plugin-tailwindcss": "0.8.1",
    "storybook": "^10.6.0",
    "ts-node": "10.9.2",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.70.0",
    "unplugin-swc": "^1.6.0",
    "vite": "^8.2.2",
    "vite-tsconfig-paths": "^6.1.1",
    "vitest": "4.1.11",
    "webpack": "^5.109.2",
    "webpack-cli": "^5.1.4",
    "webpack-dev-server": "^5.2.1"
  }
}
